import { Injectable } from '@angular/core';
import { BroadcastService } from '@shared/services/broadcast/broadcast.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderFactory {
  constructor(private broadcastService: BroadcastService) { }

  open:boolean = false;
  from:string = '';

  openLoader(from:string) {
    if(!this.open){
      this.from = from;
      this.open = true;
      this.openSpinner();
    }
  }

  closeLoader(loaders:any) {
    if(!Array.isArray(loaders)){
      loaders = [loaders];
    }
    loaders.forEach((from:any) => {
      if(this.open && this.from === from){
        this.closeSpinner();
      }
    });
  }

  closeError() {
    this.closeSpinner();
  }

  openFrom(from: string):boolean {
    return (this.from === from);
  }

  openSpinner(){
    this.broadcastService.broadcast('spinnerLoading', {showSpinnerLoading: true});
  }

  closeSpinner(){
    this.from = '';
    this.open = false;
    this.broadcastService.broadcast('spinnerLoading', {showSpinnerLoading: false});
  }
}
